import { Link } from "react-router-dom";
import { getScoreTier } from "@/lib/theme";
import { SaturationBadge } from "./SaturationBadge";
import type { Opportunity } from "@/lib/mock-data";

interface CompactOpportunityCardProps {
  opportunity: Opportunity;
}

export function CompactOpportunityCard({ opportunity }: CompactOpportunityCardProps) {
  const tier = getScoreTier(opportunity.compositeScore);
  const color = tier?.color ?? "#555";
  const displayName = opportunity.opportunityName || opportunity.title;
  const pitch = opportunity.elevatorPitch || opportunity.description;

  return (
    <Link
      to={`/opportunities/${opportunity.id}`}
      className="flex items-start gap-3 p-3 rounded-lg bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.04)] hover:bg-[rgba(255,255,255,0.06)] transition-colors"
    >
      {/* Score circle */}
      <div
        className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 font-mono font-bold text-[15px]"
        style={{
          border: `2px solid ${color}`,
          color,
          boxShadow: `0 0 12px ${color}20`,
        }}
      >
        {Math.round(opportunity.compositeScore)}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 mb-0.5">
          <SaturationBadge level={opportunity.saturationLevel} />
          {opportunity.confidence && (
            <span className="text-[9px] text-[#5A6A68] uppercase tracking-wider">
              {opportunity.confidence}
            </span>
          )}
        </div>
        <p className="text-[13px] font-semibold text-foreground leading-tight line-clamp-1">
          {displayName}
        </p>
        {pitch && (
          <p className="text-[11px] text-[#5A6A68] leading-tight line-clamp-1 mt-0.5">
            {pitch}
          </p>
        )}
        <div className="flex items-center gap-2 mt-1 text-[10px] text-[#5A6A68]">
          <span>{opportunity.industry}</span>
          {opportunity.signalCount && (
            <>
              <span>&middot;</span>
              <span className="font-mono">{opportunity.signalCount} signals</span>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}
